import moment from 'moment'

export function emailValidation(email) {
	let reg = new RegExp(
		// eslint-disable-next-line
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	)

	return reg.test(email)
}

export default function isValidName(str) {
	if (str === undefined || str === '') {
		return false
	}
	return !/[^a-zA-Z ]/.test(str)
}

export function mobileNumberValidation(number) {
	return number.length === 10
}

export function dateValidation(dateValue) {
	return moment(dateValue, 'DD/MM/YYYY', true).isValid()
}

export function passportValidation(passport) {
	// let regsaid = /[a-zA-Z]{2}[0-9]{7}/;
	return passport.length === 8 && !/[^a-zA-Z0-9]/.test(passport)
}

export function expiryDateValidation(expDate, lastDate) {
	let tripLastDate = moment(lastDate, 'DD/MM/YYYY').add(6, 'M')
	let expDateMoment = moment(expDate, 'DD/MM/YYYY')

	return expDateMoment.diff(tripLastDate, 'days', false) > 0
}

export function issueDateValidation(issueDate, birthDate) {
	let currentDate = moment(moment(), 'DD/MM/YYYY')
	let issueDateMoment = moment(issueDate, 'DD/MM/YYYY')
	return (
		issueDateMoment.diff(currentDate, 'days', false) < 0 &&
		(birthDate
			? moment(birthDate, 'DD/MM/YYYY').diff(issueDateMoment, 'days', false) < 0
			: true)
	)
}

export function childAgeValidation(ages, birthDay, lastDate) {
	// console.log('Age entered', age);
	// console.log('Trip lastDate', lastDate);
	// console.log('birthDay', birthDay);

	let ageWhenReturn = moment(lastDate, 'DD/MM/YYYY').diff(
		moment(birthDay, 'DD/MM/YYYY'),
		'years',
		false,
	)
	// console.log('Age when return', ageWhenReturn);
	let isValid = ages.some(age => {
		return ageWhenReturn === age
	})
	return {
		isValid: isValid,
		currentAge: ageWhenReturn,
	}
}

export function adultAgeValidation(age, birthDay, lastDate) {
	// console.log('Age entered', age);
	// console.log('Trip lastDate', lastDate);
	// console.log('birthDay', birthDay);

	let ageWhenReturn = moment(lastDate, 'DD/MM/YYYY').diff(
		moment(birthDay, 'DD/MM/YYYY'),
		'years',
		false,
	)
	// console.log('Age when return', ageWhenReturn);
	return {
		isValidAge: ageWhenReturn > age && ageWhenReturn < 100,
		invalidCalculation: ageWhenReturn > 100,
	}
}
